import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

import OnboardingVerification from './index'
import styles from './OnboardingVerification.module.scss'

const coverageLabels = {
  covered: 'Data available',
  partial: 'Partial data',
  missing: 'Missing data'
}

function groupCoverageByYear(monthlyCoverage) {
  return monthlyCoverage.reduce((years, month) => {
    const existingYear = years.find(year => year.year === month.year)

    if (existingYear) {
      existingYear.months.push(month)
      return years
    }

    return [...years, { year: month.year, months: [month] }]
  }, [])
}

const OnboardingVerificationDialog = ({ verification, onClose }) => {
  const coverageByYear = groupCoverageByYear(verification?.monthlyCoverage ?? [])
  const coverageTotals = (verification?.monthlyCoverage ?? []).reduce(
    (totals, month) => ({ ...totals, [month.status]: totals[month.status] + 1 }),
    { covered: 0, partial: 0, missing: 0 }
  )

  return (
    <ConfirmationDialog
      title="Verify onboarding status"
      maxWidth={900}
      hasConfirmButton={false}
      onClose={onClose}
      contentPadding="0 24px 24px"
    >
      <OnboardingVerification verification={verification} />

      <section className={styles.coverageSection}>
        <div className={styles.coverageHeader}>
          <div>
            <h3>Historical data by month</h3>
            <p>
              The expected six-year window is shown below. Use it to identify exactly
              where historical data is missing.
            </p>
          </div>
          <div className={styles.coverageTotals}>
            <span className={styles.coveredText}>{coverageTotals.covered} available</span>
            <span className={styles.partialText}>{coverageTotals.partial} partial</span>
            <span className={styles.missingText}>{coverageTotals.missing} missing</span>
          </div>
        </div>

        <div className={styles.coverageLegend}>
          {Object.entries(coverageLabels).map(([status, label]) => (
            <span key={status}>
              <i className={styles[`${status}Month`]} /> {label}
            </span>
          ))}
        </div>

        <div className={styles.coverageYears}>
          {coverageByYear.map(year => (
            <div key={year.year} className={styles.coverageYear}>
              <strong>{year.year}</strong>
              <div className={styles.coverageMonths}>
                {year.months.map(month => (
                  <span
                    key={month.key}
                    className={styles[`${month.status}Month`]}
                    title={`${month.fullLabel}: ${coverageLabels[month.status]}`}
                  >
                    {month.label}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </ConfirmationDialog>
  )
}

export default OnboardingVerificationDialog
